import { faFlask } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Badge, Button, Col, Modal, Row, Spinner } from 'react-bootstrap-5';

type EnrichListModalCompleteProps = {
  listUrl: string;
  loadingCredits: boolean;
  propertiesEnriched: number;
  propertiesNotEnriched: number;
  remainingCredits: number;
  setModalStage: (stage: number) => void;
}

export default function EnrichListModalComplete(
  { loadingCredits, listUrl, propertiesEnriched, propertiesNotEnriched, remainingCredits, setModalStage }: EnrichListModalCompleteProps
) {
  return (
    <>
      <Modal.Header className="flex-row" closeButton>
        <div className="d-flex flex-column w-100">
          <Badge bg="" className="text-body fw-normal rounded muted me-auto" style={{ fontSize: '0.875rem' }}>
            <FontAwesomeIcon className="me-1 text-secondary" icon={faFlask}/>
            BETA
          </Badge>
          <Modal.Title as="h5">Enrichment Complete</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Row className="pb-4 pt-1">
          <Col xs={8}>
            We've successfully completed your enrichment. Here's a summary of the results.
          </Col>
          <Col className="ps-0" xs="auto">
            <Badge bg="" bsPrefix="badge mh-100" className="py-2 px-3 text-muted fw-normal rounded muted">
              <span className="fs-x-small me-2">
                Credit Remaining
              </span>
              <strong className="fs-large">
                {loadingCredits ? <Spinner animation="border" size="sm" /> : remainingCredits}
              </strong>
            </Badge>
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <Badge bg="" className="w-100 mh-100 flex-nowrap align-items-start p-2 gap-0 text-muted fw-normal rounded muted d-flex flex-column" style={{ fontSize: '0.875rem' }}>
              <strong className="fs-large me-2">{propertiesEnriched} </strong>
              <span className="fs-x-small text-muted">Properties Enriched</span>
            </Badge>
          </Col>
          <Col xs={6}>
            <Badge bg="" className="w-100 mh-100 flex-nowrap align-items-start p-2 gap-0 text-muted fw-normal rounded muted d-flex flex-column" style={{ fontSize: '0.875rem' }}>
              <strong className="fs-large me-2">{propertiesNotEnriched} </strong>
              <span className="fs-x-small text-muted">Properties Not Enriched</span>
            </Badge>
          </Col>
        </Row>
        <Row className="pt-2">
          <Col>
            <small className="text-muted">
              Any properties that were not enriched already had contacts unlocked or had no discoverable contacts.
            </small>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" onClick={() => setModalStage(0)}>
          Close
        </Button>
        <Button variant="secondary" onClick={() => {
          if (window.top) window.top.location.href = listUrl;
        }}
        >
          View List
        </Button>
      </Modal.Footer>
    </>
  );
}
